const DASHBOARD_SESSION_EVENT_LABELS = {
  DASHBOARD_SESSION_CHECK_ALIVE: 'Dashboard session active',
  DASHBOARD_SESSION_CHECK_DEAD: 'Dashboard session expired',
  DASHBOARD_SESSION_REFRESH_SUCCEEDED: 'Dashboard session refreshed',
  DASHBOARD_SESSION_REFRESH_FAILED: 'Dashboard session refresh failed',
  DASHBOARD_SESSION_REFRESH_SKIPPED: 'Dashboard session refresh skipped',
  DASHBOARD_SESSION_PROMPT_SHOWN: 'Dashboard login notification',
  DASHBOARD_SESSION_LOGIN_NAV: 'Opened dashboard login page',
  DASHBOARD_SESSION_RENDERER_DEAD: 'Dashboard web view not logged in',
  PEP_POST_UPDATE_RECOVERY: 'Post-update recovery',
  PEP_STALE_GAP_CATCH_UP_TRIGGERED: 'Autonomous stale sync catch-up started',
  PEP_STALE_GAP_CATCH_UP_SKIPPED: 'Autonomous stale sync catch-up skipped'
}

function parseLegacyTelemetryFields(raw) {
  const fields = {}
  if (!raw || typeof raw !== 'string') {
    return fields
  }
  const pattern = /(\w+)=([^\s]+)/g
  let match = pattern.exec(raw)
  while (match != null) {
    fields[match[1]] = match[2]
    match = pattern.exec(raw)
  }
  return fields
}

function messageBeforeTechnicalSuffix(raw) {
  if (!raw || typeof raw !== 'string') {
    return ''
  }
  const idx = raw.indexOf(' (eventCode=')
  if (idx > 0) {
    return raw.slice(0, idx).trim()
  }
  return raw.trim()
}

export function isDashboardSessionTelemetryEvent(ev) {
  const type = (ev.eventType ?? ev.EventType ?? '').trim()
  const code = (ev.eventCode ?? ev.EventCode ?? '').trim()
  if (type === 'DashboardSession' || type === 'AppRecovery') {
    return true
  }
  return Object.prototype.hasOwnProperty.call(DASHBOARD_SESSION_EVENT_LABELS, code)
}

export function dashboardSessionEventShortLabel(eventCode) {
  const code = (eventCode || '').trim()
  return DASHBOARD_SESSION_EVENT_LABELS[code] || ''
}

export function formatDashboardSessionOperationalMessage(ev) {
  const raw = (ev.message ?? ev.Message ?? '').trim()
  const fromMessage = messageBeforeTechnicalSuffix(raw)
  if (fromMessage) {
    return fromMessage
  }

  const eventCode = (ev.eventCode ?? ev.EventCode ?? '').trim()
  const fields = parseLegacyTelemetryFields(raw)

  switch (eventCode) {
    case 'DASHBOARD_SESSION_CHECK_ALIVE':
      return 'Dashboard API login check succeeded; the hotel user session is active.'
    case 'DASHBOARD_SESSION_CHECK_DEAD':
      return `Dashboard API login check failed or the session expired${fields.reason ? ` (${fields.reason})` : ''}.`
    case 'DASHBOARD_SESSION_REFRESH_SUCCEEDED':
      return 'Dashboard session was refreshed successfully via authorize.'
    case 'DASHBOARD_SESSION_REFRESH_FAILED':
      return `Dashboard session refresh via authorize failed${fields.reason ? ` (${fields.reason})` : ''}.`
    case 'DASHBOARD_SESSION_REFRESH_SKIPPED':
      return `Dashboard session refresh was skipped${fields.reason ? ` (${fields.reason})` : ''}.`
    case 'DASHBOARD_SESSION_PROMPT_SHOWN':
      return 'The desktop app showed a notification asking the user to sign in to the dashboard again.'
    case 'DASHBOARD_SESSION_LOGIN_NAV':
      return 'The embedded dashboard was opened on the login page to recover a missing web user token.'
    case 'DASHBOARD_SESSION_RENDERER_DEAD':
      return 'The dashboard web view reported that the user is not logged in.'
    case 'PEP_POST_UPDATE_RECOVERY':
      return `One-time recovery ran after a desktop app update${fields.version ? ` (version ${fields.version})` : ''}.`
    default:
      return raw || 'Dashboard session activity was recorded.'
  }
}
